import axios from 'axios';
import store from '../store';
import jquery from 'jquery';
import apis from '../configs/apis';

const HTTP = axios.create({
    baseURL: apis.my.url,
    paramsSerializer: (params) => {
        return jquery.param(params);
    }
});

HTTP.interceptors.request.use(
  config => {
    const token = store.getters['user/token'];
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    store.dispatch('indicators/loading', true);
    store.dispatch('indicators/increasePendingRequests');
    return config;
  }
);

HTTP.interceptors.response.use((response) => {
  store.dispatch('indicators/loading', false);
  store.dispatch('indicators/decreasePendingRequests');

  if (response.headers.authorization) {
    const token = response.headers.authorization.replace('Bearer ', '');
    store.commit('user/storeToken', token);
  }

  /*
  if (typeof response.data.code !== 'undefined') {
    switch(response.data.code) {
      case 103: // token blacklisted.
        store.dispatch('user/logout', {force: true});
        break;
    }
  }
  */
  return response;
}, (error) => {
  store.dispatch('indicators/loading', false);
  store.dispatch('indicators/decreasePendingRequests');
  /*
  if (error.response.data.status_code == 401 &&
    error.response.data.message.indexOf('expired') !== -1 &&
    store.getters['user/token']) {
      // try to refresh token
      let previousRequest = error.config;
      return store.dispatch('user/refreshToken').then(function(response) {
        const token = store.getters['user/token'];
        if (token) {
          previousRequest.headers.Authorization = `Bearer ${token}`;
        }
        store.dispatch('indicators/setSubmitIndicator', true);
        return HTTP.request(previousRequest);
      }, function(error) {
        store.dispatch('user/logout', {force: true});
      });
  }
  */

  /*
  if (error.response && error.response.data.status_code == 401) {
      store.commit('user/clearUser');
      router.push({name: 'home'});
  }*/

  return Promise.reject(error);
});

export default HTTP;
